import { useEffect } from 'react'
import { useAccount, useChains, useWalletClient } from 'wagmi'
import { useAccountChainStatus } from './useAccountChainStatus'

/**
 * Watches for missing networks and adds them to the wallet client.
 */
export function useWatchMissingNetworks() {
	const chains = useChains()
	const chainStatus = useAccountChainStatus()
	const { data: walletClient } = useWalletClient()
	const { connector } = useAccount()

	useEffect(() => {
		if (!walletClient || !connector || chainStatus !== 'unsupported') {
			return
		}

		const addMissingNetwork = async () => {
			const chainId = await connector.getChainId()
			const chainToAdd = chains.find(c => c.id === chainId)

			if (!chainToAdd) {
				console.error('Chain not found: ', chainId)

				return
			}

			walletClient.addChain({ chain: chainToAdd }).catch(e => console.error('Failed to add missing network: ', e))
		}

		addMissingNetwork()
	}, [walletClient, chains, chainStatus])
}
